module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/react-router-dom/~/react-router/~/path-to-regexp/~/isarray/index.js
// module id = 219
// module chunks = 0